import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomProductsRoutingModule } from './custom-products-routing.module';
import { SharedModule } from "@app/shared/shared.module";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    CustomProductsRoutingModule
  ]
})
export class CustomProductsModule { }
